import Lottie from "lottie-react";

import programLoadingAnimation from "~/public/lottie-animations/program-loading-2.json";

interface ExamReviewBuildingProps {
	currentTip: string;
	progress: number;
}

const ExamReviewBuilding = ({
	currentTip,
	progress,
}: ExamReviewBuildingProps) => (
	<div className="flex flex-col items-center justify-center gap-10 px-8 py-24">
		<Lottie
			animationData={programLoadingAnimation}
			loop
			className="-m-16 -mt-28 aspect-square laptop:w-120 w-96 dark:opacity-20"
		/>
		<div className="flex flex-col items-center justify-center gap-4">
			<div className="h-2 w-96 max-w-[80vw] overflow-hidden rounded-full bg-slate-200 shadow-inner dark:bg-slate-700">
				<div
					className="h-full rounded-full bg-slate-700 shadow transition-all duration-500 ease-in-out dark:bg-slate-100"
					style={{ width: `${progress}%` }}
				/>
			</div>
			<p key={currentTip} className="animate-fade-in font-medium">
				{currentTip}
			</p>
		</div>
	</div>
);

export default ExamReviewBuilding;
